import script from "./SortModalMolecule.vue?vue&type=script&setup=true&lang=ts"
export * from "./SortModalMolecule.vue?vue&type=script&setup=true&lang=ts"

import "./SortModalMolecule.css?vue&type=style&index=0&id=f81738b2&scoped=true&lang=css&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f81738b2"]])

export default __exports__